/**
 * Pagar com SALDO da carteira — interruptor único.
 *
 * DESLIGADO. A carteira ainda não foi lançada ao público (ordem da Linda,
 * 19/10/2026), por isso a opção «Saldo Pagali» não aparece em lado nenhum,
 * mesmo que o utilizador tenha saldo.
 *
 * O que está do lado do servidor FICA: `/client/payments/initiate` com
 * `paymentMethod: 'wallet'` liga o pagamento ao donativo e confirma-o
 * (serviço `donativo-pago`). Isso é a correcção de um defeito — sem ela o saldo
 * saía e o donativo ficava por confirmar — e não abre nada ao público, porque
 * nenhuma interface o oferece enquanto esta constante for `false`.
 *
 * Para ligar quando a carteira for lançada: pôr `true` aqui e republicar o
 * frontend. Não duplicar esta condição noutros ficheiros — foi o que aconteceu
 * com o eCard antes de existir `config/ecard.ts`.
 */
export const WALLET_PAY_ENABLED = false;
